import { filmFacts, filmSummary } from '@/mocks/facts';
import SectionHeading from './SectionHeading';

export default function FactsSection() {
  return (
    <section id="facts" className="w-full bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1180px] px-4 md:px-6">
        <SectionHeading
          eyebrow="01 / 影片档案"
          title="《蜜桃成熟时》是一部怎样的电影"
          desc={filmSummary}
        />

        <div className="mt-8 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4 md:gap-4">
          {filmFacts.map((fact) => (
            <div
              key={fact.label}
              className="flex flex-col gap-3 rounded-lg border border-background-200 bg-background-50 p-4 md:p-5"
            >
              <span className="flex items-center justify-center w-10 h-10 rounded-lg bg-primary-100 text-primary-700">
                <i className={`${fact.icon} text-xl`} />
              </span>
              <div>
                <p className="font-label text-xs text-foreground-500">{fact.label}</p>
                <p className="mt-1 font-heading text-sm font-semibold leading-snug text-foreground-950 md:text-base">
                  {fact.value}
                </p>
              </div>
            </div>
          ))}
        </div>

        <p className="mt-6 text-xs leading-relaxed text-foreground-500">
          注：以上资料依据公开资料整理，不同发行版本的片段、画质与字幕可能存在差异，具体以正式发行版本为准。
        </p>
      </div>
    </section>
  );
}